// I originally got this from: https://engineering.classdojo.com/blog/2016/12/10/catching-react-errors/
// I modified it to not try to dispatch to the store.

import ReactUpdates from 'react/lib/ReactUpdates';
import ReactDefaultBatchingStrategy from 'react/lib/ReactDefaultBatchingStrategy';

let isHandlingError = false;
const ReactTryCatchBatchingStrategy = {
	// this is part of the BatchingStrategy API. simply pass along
	// what the default batching strategy would do.
	get isBatchingUpdates () {
		return ReactDefaultBatchingStrategy.isBatchingUpdates; 
	},

	batchedUpdates (...args) {
		try {
			ReactDefaultBatchingStrategy.batchedUpdates(...args);
		} catch (e) {
			if (isHandlingError) {
				// our error handling code threw an error. just throw now
				throw e;
			}

			isHandlingError = true;
			try {
				// dispatch redux action notifying the app that an error occurred.
				// replace this with whatever error handling logic you like.
				// store.dispatch(appTriggeredError(e));
				console.error('----------------- render error!', e);
			} finally {
				isHandlingError = false;
			}
		}
	},
};

ReactUpdates.injection.injectBatchingStrategy(ReactTryCatchBatchingStrategy);



// WEBPACK FOOTER //
// ./frontend/olos/js/lib/ReactTryCatchBatchingStrategy.js